module.exports = __webpack_public_path__ + "media/images/background_image_light-0df029a948aa4f018a17bc39041fad09.jpg";